module.exports = __webpack_public_path__ + "img/images04.aa80efa4.jpg";